const SECRET = 'b7f8e2c1-4a5d-4e2b-9c3a-7f6d8e5b2a1c-20240613';

// Helper: base64url encode/decode
function base64urlEncode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function base64urlDecode(str) {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) str += '=';
  return atob(str);
}

// Helper: HMAC-SHA256 (returns base64url)
async function hmacSHA256(message, secret) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw',
    enc.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign', 'verify']
  );
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(message));
  // Convert ArrayBuffer to base64url
  const b64 = btoa(String.fromCharCode(...new Uint8Array(sig)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Encode
export async function encodeBookingToken(payload) {
  const json = JSON.stringify(payload);
  const data = base64urlEncode(json);
  const sig = await hmacSHA256(data, SECRET);
  return `${data}.${sig}`;
}

// Decode & verify
export async function decodeBookingToken(token) {
  if (!token) return null;
  const [data, sig] = token.split('.');
  if (!data || !sig) return null;
  const expectedSig = await hmacSHA256(data, SECRET);
  if (sig !== expectedSig) return null;
  try {
    return JSON.parse(base64urlDecode(data));
  } catch {
    return null;
  }
} 